type PropsType = {
  children: React.ReactNode;
  className?: string;
};

export const FormControlRow = (props: PropsType) => {
  return <div className={`control-row ${props.className}`}>{props.children} </div>;
};
